import {
  Dialog,
  Text,
  TextHighlight,
  TextWeight
} from '@focaldata/cin-ui-components'
import React from 'react'

interface Props {
  isOpen: boolean
  isLive: boolean
  toggleOpenDialog: (open: boolean) => void
  onPauseProject: () => void
  // What the dialog pauses — 'project' for single-market projects, 'market'
  // when pausing a single market of a multi-market project.
  entity?: 'project' | 'market'
  // Shows the primary button as busy while the pause/unpause is in flight.
  isSubmitting?: boolean
}

const getMainText: (isLive: boolean, entity: string) => string = (
  isLive,
  entity
) => (isLive ? `Pause ${entity}` : `Unpause ${entity}`)
const getGeneralExplanation: (isLive: boolean, entity: string) => string = (
  isLive,
  entity
) =>
  isLive
    ? `This will pause the ${entity} and all ongoing data collection.`
    : `This will unpause the ${entity}. Data collection will continue from where it was paused.`

const getAdditionalExplanation: (isLive: boolean, entity: string) => string = (
  isLive,
  entity
) =>
  isLive
    ? `If you leave the ${entity} paused for longer than 10 business days, then the ${entity} will automatically end.`
    : `You can pause the ${entity} again at any point.`

const DialogPauseProject: React.FC<Props> = (props: Props) => {
  const {
    isOpen,
    isLive,
    toggleOpenDialog,
    onPauseProject,
    entity = 'project',
    isSubmitting = false
  }: Props = props
  return (
    <Dialog
      open={isOpen}
      onClickOutside={() => toggleOpenDialog(false)}
      onClose={() => toggleOpenDialog(false)}
      title={getMainText(isLive, entity)}
      primaryButtonText={getMainText(isLive, entity)}
      primaryButtonClick={onPauseProject}
      primaryButtonLoading={isSubmitting}
      primaryButtonDisabled={isSubmitting}
    >
      <Text weight={TextWeight.SemiBold} gutterBottom>
        {getGeneralExplanation(isLive, entity)}
      </Text>
      <Text highlight={TextHighlight.Background}>
        {getAdditionalExplanation(isLive, entity)}
      </Text>
    </Dialog>
  )
}

export default DialogPauseProject
